export default __webpack_public_path__ + "static/media/soundrecording.76ad24cc.png";